import React from 'react'
import Footer from '../componets/Footer';

function Contact() {
  return (
    <div className="contact-page">
      <Footer/>
    </div>
  )
}

export default Contact;